<template>
  <div>
    <b-form-group label="Conselho:">
      <SelectConselho
        ref="selectConselho"
        v-model="cms_page.conselho_id"
        :state="validateState('conselho_id')"
      ></SelectConselho>
      <b-form-invalid-feedback :state="validateState('conselho_id')"
        >Conselho é um campo obrigatório.
      </b-form-invalid-feedback>
    </b-form-group>

    <div class="row">
      <b-form-group label="Título no Menu:" class="col-7">
        <b-form-input
          v-model="cms_page.menu"
          placeholder="Título no Menu"
          :state="validateState('menu')"
        ></b-form-input>
        <b-form-invalid-feedback
          >Título do menu é um campo obrigatório.</b-form-invalid-feedback
        >
      </b-form-group>

      <b-form-group label="Exibir no Menu:" class="col-5">
        <b-form-radio-group
          v-model="cms_page.show_menu"
          class="radio-show-menu"
        >
          <b-form-radio :value="true">Sim</b-form-radio>
          <b-form-radio :value="false">Não</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </div>

    <b-form-group label="Título da Página:">
      <b-form-input
        v-model="cms_page.title"
        placeholder="Título"
        :state="validateState('title')"
      ></b-form-input>
      <b-form-invalid-feedback
        >Título é um campo obrigatório.</b-form-invalid-feedback
      >
      <b-form-text id="input-live-help">{{ url }}</b-form-text>
    </b-form-group>

    <b-form-group label="Status:">
      <b-form-select
        v-model="cms_page.status"
        :options="status_options"
        :state="validateState('status')"
      ></b-form-select>
      <b-form-invalid-feedback>
        Status é um campo obrigatório.
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Conteúdo">
      <div class="cms_editor">
        <Editor
          v-model="cms_page.content"
          placeholder="Conteúdo da Página"
          class="cms-editor"
        ></Editor>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import SelectConselho from "@/modules/conselhos/Components/SelectConselho";
import Editor from "@/components/Form/Editor.vue";
import { mapGetters, mapState } from "vuex";
import slugify from "@/helpers/functions/slugify";

export default {
  mixins: [validationMixin],
  components: {
    SelectConselho,
    Editor,
  },
  data: () => ({
    status_options: [
      {
        text: "Rascunho",
        value: "draft",
      },
      {
        text: "Publicado",
        value: "published",
      },
      {
        text: "Arquivado",
        value: "archived",
      },
    ],
  }),
  validations: {
    cms_page: {
      menu: {
        required,
        minLength: minLength(3),
      },
      title: {
        required,
        minLength: minLength(3),
      },
      conselho_id: {
        required,
      },
      status: {
        required,
      },
    },
  },
  computed: {
    ...mapState("cms_pages", ["cms_page"]),
    ...mapGetters("conselhos", ["getUrlConselho"]),
    ...mapGetters("auth", ["GetUrlClient"]),
    conselho() {
      return (
        this.cms_page.conselho_id &&
        this.$refs.selectConselho &&
        this.$refs.selectConselho.getConselho()
      );
    },
    url() {
      let url = "";
      let sigla = this.conselho ? this.conselho.sigla : "";

      if (this.cms_page.title && sigla) {
        url = "https://";
        url += sigla + ".";
        url += this.GetUrlClient[0] + "/page";
        url += "/" + slugify(this.cms_page.title);
      }
      return url;
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.cms_page[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.cms_page.$touch();
      return !this.$v.cms_page.$anyError;
    },
  },
  created() {
    if (!this.cms_page.id) {
      this.cms_page.status = "draft";
      this.cms_page.show_menu = false;
    }
  },
};
</script>

<style lang="scss">
.cms_editor {
  .ck-editor__editable {
    min-height: 300px;
  }
}
</style>
